"use client";

import { HeroStage } from "./HeroStage";

// Wide live demo section — places the HeroStage in a section with a copy header
export function LiveDemo() {
  return (
    <section id="demo" className="live-demo">
      <div className="shell">
        <div className="ld-head">
          <span className="section-eyebrow">LIVE · 실제 사용 시나리오</span>
          <h2 className="ld-title">카미봇이 들어오면 이런 일이 일어나요</h2>
          <p className="ld-sub">
            가변 음성 채널을 만들고, 자동으로 임시방을 띄우고, 텍스트와 음성을 연결하고,
            인기 TTS 목소리로 바꾸기까지 — 슬래시 한 번에서 시작합니다.
            <span className="ld-hint">
              ▸ 마우스를 올리면 멈추고, 클릭하면 다음 단계로 넘어가요
            </span>
          </p>
        </div>

        <div className="ld-frame">
          <HeroStage />
        </div>
      </div>
    </section>
  );
}

export default LiveDemo;
